import React, { useState } from 'react';
import { X, BookmarkPlus } from 'lucide-react';
import CustomLoader from '../../../shared/components/ui/CustomLoader';
import { createPptVersion } from '../utils/pptVersionService';
import { extractApiError } from '../utils/apiErrorUtils';
import './PptVersionModals.css';

const SaveCheckpointModal = ({ rfpId, onClose, onSuccess, currentVersionNumber = 6, draftCount = 0 }) => {
    const [comment, setComment] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const nextVersionNumber = (currentVersionNumber || 6) + 1;

    const handleSave = async () => {
        setSaving(true);
        setError('');
        try {
            const result = await createPptVersion(rfpId, comment.trim());
            onSuccess(result, nextVersionNumber);
        } catch (err) {
            console.error('Save checkpoint error:', err);
            setError(extractApiError(err, 'Failed to save checkpoint.'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="pvm-overlay" onClick={onClose}>
            <div className="pvm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="pvm-header">
                    <div className="pvm-header-icon">
                        <BookmarkPlus size={20} color="#FF5526" />
                    </div>
                    <div>
                        <h3 style={{ margin: '0 0 2px 0', fontSize: '1.05rem', fontWeight: 700 }}>Create Version {nextVersionNumber}?</h3>
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B' }}>
                            {draftCount > 0 ? `${draftCount} unsaved draft change(s) pending.` : 'Save current presentation as a checkpoint.'}
                        </p>
                    </div>
                    <button className="pvm-close-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                {error && <div className="pvm-error">{error}</div>}

                <div className="pvm-body">
                    <div className="pvm-field">
                        <label>Comment <span>(Optional)</span></label>
                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="e.g. Updated project requirements"
                            rows={3}
                            maxLength={500}
                        />
                        <span className="pvm-char-count">{comment.length}/500</span>
                    </div>
                </div>

                <div className="pvm-footer">
                    <button className="pvm-btn-outline" onClick={onClose} disabled={saving}>
                        Cancel
                    </button>
                    <button className="pvm-btn-primary" onClick={handleSave} disabled={saving}>
                        {saving ? <CustomLoader size={14} color="white" /> : <BookmarkPlus size={14} />}
                        <span>Save Checkpoint</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveCheckpointModal;
